import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=4a2145fc&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=4a2145fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2145fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a2145fc')) {
      api.createRecord('4a2145fc', component.options)
    } else {
      api.reload('4a2145fc', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=4a2145fc&scoped=true&", function () {
      api.rerender('4a2145fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2lO4WQTPxcrHq/JS/comp/DateRangeExt.vue"
export default component.exports